import { motion, useInView } from "framer-motion"
import { graphql } from "gatsby"
import React, { useEffect, useRef, useState } from "react"

const IconGrid = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`general-icon-grid py-60 !pb-90 mdscreen2:py-45 bg-pattern-2 pattern-square ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-sm"
          >
            {module?.icons && (
              <motion.div
                variants={animFade}
                className="grid grid-cols-5 mdscreen:grid-cols-3 smscreen2:grid-cols-2 gap-50 md:gap-[90px] md:max-w-[700px] mx-auto"
              >
                {module?.icons.map((item, i) => (
                  <div
                    className="icon flex flex-col items-center text-center"
                    key={i}
                  >
                    {item?.icon && (
                      <div className="icon-img">
                        <img
                          src={item.icon.mediaItemUrl}
                          width={75}
                          height={75}
                          loading="lazy"
                          alt={item.icon.title}
                          className="mdscreen:h-[60px] mdscreen:w-[60px]"
                        />
                      </div>
                    )}
                    {item?.heading && (
                      <span className="text-grey-100 text-28 leading-36 font-headingSecondary block pt-20 lowercase">
                        {item.heading}
                      </span>
                    )}
                  </div>
                ))}
              </motion.div>
            )}
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default IconGrid
export const PageIconGridFragment = graphql`
  fragment PageIconGridFragment on WpPage_Pagecontent_PageContent_IconGrid {
    extraClass
    extraId
    hideSection
    icons {
      heading
      icon {
        altText
        mediaItemUrl
        title
      }
    }
  }
`
